module.exports = __webpack_public_path__ + "bc573972c7a19045c5df79e91683e255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/rectangleborder.svg
// module id = 134
// module chunks = 1